export { default } from './MarketScanConfirmPurchase';
